import {
  TrackingPageContext,
  TrackingPageTypeWithId,
  TrackingPageTypeWithoutId,
} from '../../../types';
import {TrackingClientStateHolder} from '../helpers/clientState';
import {contentView} from '../helpers/contentView';
import {SourceHistoryEventData} from '../helpers/sourceHistory';

export interface ContentViewEvent {
  GA4: ContentViewEventGA4;
}
export interface ContentViewEventGA3 {
  event: 'contentView';
  shopVersion: string;
  shopId: string;
  timestamp: number;
  contentName: string;
  search: string;
  pageType: TrackingPageTypeWithId | TrackingPageTypeWithoutId;
  pageTypeId: number | string | null;
  breadcrumbs: string[];
  loadingTimeInSeconds: number;
  source: SourceHistoryEventData['source'];
  // origin click is string | null as if its null we dont push this field to data layer
  originClick: string | null;
}

export interface ContentViewEventGA4 {
  event: 'content_view';
  content_name: string;
  // document.title
  title: string | null;
  page_type: TrackingPageTypeWithId | TrackingPageTypeWithoutId;
  page_type_id: number | string | null;
  // origin click is string | null as if its null we dont push this field to data layer
  click_origin: string | null;
  content_client_group: string;
}

export const trackContentView =
  ({page}: {page: TrackingPageContext}) =>
  (clientState: TrackingClientStateHolder) => {
    const {eventGA4} = contentView({
      page,
    })(clientState);

    clientState.update({originClick: ''});

    const event = {
      GA4: eventGA4,
    };

    return event;
  };
